export default function ({ store, redirect, error, route }) {
  const logged = store.getters['authentication/logged']
  const allowed = store.getters['authentication/isLP']
  if (logged) {
    if (!allowed) return error({ status: 403 })
  } else {
    store.dispatch('authentication/logout')
    redirect({
      name: 'login',
      query: {
        to: route.fullPath
      }
    })
  }
}
